"use strict";

exports.__esModule = true;
exports.chartTheme = exports.ECHARTS_THEME = exports.CHART_SERIES_PALETTE = void 0;
var echarts = _interopRequireWildcard(require("echarts"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * The echarts theme for every echarts-for-react chart in the app.
 *
 * Registered once at import time; pass `theme={ECHARTS_THEME}` to ReactECharts.
 * It mirrors the chart language of the next-gen reference design and the
 * Chart* tokens in Themes/base: horizontal-only gridlines, no axis lines or
 * tick marks, mono muted axis labels, 1.4px series, white bordered tooltips.
 *
 * Per-series options set in code (a user-picked colour, a smooth toggle, a
 * mark line colour) still win: a theme only supplies defaults.
 */
var ECHARTS_THEME = exports.ECHARTS_THEME = "vimana";
var CHART_SERIES_PALETTE = exports.CHART_SERIES_PALETTE = ["#3A86C8",
// blue
"#E8621E",
// orange
"#2E9E5B",
// green
"#D8453B",
// red
"#6E7B85",
// slate
"#9FB4C4",
// steel
"#8FD8A4",
// mint
"#F08A63",
// peach
"#3D4A53",
// ink
"#C7CFD5" // grey
];
var MONO = 'ui-monospace, Menlo, Consolas, "DejaVu Sans Mono", monospace';
var GRID = "#EFF2F4";
var AXIS_TEXT = "#8B98A1";
var LEGEND_TEXT = "#5A6771";
var INK = "#1B2227";
var ACCENT = "#3A86C8";
var LINE = "#E3E7EA";
var axis = {
  axisLine: {
    show: false
  },
  axisTick: {
    show: false
  },
  axisLabel: {
    color: AXIS_TEXT,
    fontFamily: MONO,
    fontSize: 10.5
  },
  nameTextStyle: {
    color: "#7C8A94",
    fontSize: 11
  },
  splitLine: {
    show: true,
    lineStyle: {
      color: [GRID],
      width: 1,
      type: "solid"
    }
  },
  splitArea: {
    show: false
  }
};

// Category and time axes run along the bottom: no vertical gridlines from them.
var bottomAxis = Object.assign({}, axis, {
  splitLine: {
    show: false
  }
});
var chartTheme = exports.chartTheme = {
  color: CHART_SERIES_PALETTE,
  backgroundColor: "transparent",
  textStyle: {
    color: LEGEND_TEXT
  },
  title: {
    textStyle: {
      color: INK,
      fontSize: 14,
      fontWeight: 600
    },
    subtextStyle: {
      color: "#7C8A94",
      fontSize: 11.5
    }
  },
  line: {
    lineStyle: {
      width: 1.4
    },
    symbolSize: 4
  },
  scatter: {
    symbolSize: 6
  },
  bar: {
    barMaxWidth: 32
  },
  pie: {
    itemStyle: {
      borderColor: "#ffffff",
      borderWidth: 2
    },
    label: {
      color: LEGEND_TEXT
    }
  },
  categoryAxis: bottomAxis,
  timeAxis: bottomAxis,
  valueAxis: axis,
  logAxis: axis,
  legend: {
    textStyle: {
      color: LEGEND_TEXT,
      fontSize: 11
    },
    itemWidth: 12,
    itemHeight: 8,
    itemGap: 14,
    icon: "roundRect",
    inactiveColor: "#C7CFD5",
    pageTextStyle: {
      color: LEGEND_TEXT
    },
    pageIconColor: LEGEND_TEXT,
    pageIconInactiveColor: "#C7CFD5"
  },
  tooltip: {
    backgroundColor: "#ffffff",
    borderColor: LINE,
    borderWidth: 1,
    padding: [8, 10],
    textStyle: {
      color: INK,
      fontSize: 12
    },
    extraCssText: "border-radius:8px;box-shadow:0 1px 2px rgba(29,36,41,.06),0 12px 28px rgba(29,36,41,.16);",
    axisPointer: {
      lineStyle: {
        color: ACCENT,
        width: 1
      },
      crossStyle: {
        color: ACCENT,
        width: 1
      },
      shadowStyle: {
        color: "rgba(58, 134, 200, 0.08)"
      },
      label: {
        backgroundColor: INK,
        color: "#ffffff",
        fontFamily: MONO,
        fontSize: 10.5,
        borderRadius: 4
      }
    }
  },
  dataZoom: {
    backgroundColor: "transparent",
    borderColor: LINE,
    dataBackground: {
      lineStyle: {
        color: "#9FB4C4",
        width: 1
      },
      areaStyle: {
        color: "rgba(159, 180, 196, 0.25)"
      }
    },
    selectedDataBackground: {
      lineStyle: {
        color: ACCENT,
        width: 1
      },
      areaStyle: {
        color: "rgba(58, 134, 200, 0.25)"
      }
    },
    fillerColor: "rgba(58, 134, 200, 0.08)",
    handleStyle: {
      color: ACCENT,
      borderColor: ACCENT
    },
    moveHandleStyle: {
      color: "#9FB4C4"
    },
    textStyle: {
      color: AXIS_TEXT,
      fontFamily: MONO,
      fontSize: 10.5
    }
  },
  markLine: {
    lineStyle: {
      color: "#6E7B85",
      type: "dashed",
      width: 1
    },
    label: {
      color: LEGEND_TEXT,
      fontFamily: MONO,
      fontSize: 10.5
    }
  },
  markPoint: {
    label: {
      color: INK
    }
  },
  toolbox: {
    iconStyle: {
      borderColor: AXIS_TEXT
    },
    emphasis: {
      iconStyle: {
        borderColor: ACCENT
      }
    }
  },
  visualMap: {
    textStyle: {
      color: LEGEND_TEXT
    }
  }
};
echarts.registerTheme(ECHARTS_THEME, chartTheme);